import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from './ErrorPage';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

@connect()
export default class Error500Page extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    params: PropTypes.object
  };

  constructor(props) {
    super(props);

    const {
      dispatch,
      params: {
        splat = ""
      } = {}
    } = this.props;

    const [flag, ...path] = splat.split("/");

    if (typeof history !== "undefined" && (flag == "from")) {
      setTimeout(() => {
        dispatch(replace(`/error/500/${path.join("/")}`));
      }, 100); // give the "from" page time for its analytics to be ignored
    }
  }

  render() {
    return <ErrorPage title="Server Error">There has been an error and we can't continue. Our engineers have been notified and will resolve it as soon as possible.</ErrorPage>;
  }
}


// WEBPACK FOOTER //
// ./modules/Errors/components/Error500Page.js